import { useState } from 'react';
import toast from 'react-hot-toast';
import { namespaces, useSharedTranslation } from 'us-react-components/dist/hooks/useSharedTranslation';
import { ToggleSwitch } from 'us-react-components/dist/ToggleSwitch/ToggleSwitch';
import { axios, SitterPaymentSettingsService } from 'us-web-services';
import { useDependencies } from '../../dependencies';

export const AcceptingPaymentToggle = (): JSX.Element => {
  const { t } = useSharedTranslation(namespaces.caregiver);
  const { stores } = useDependencies();
  const { sitter: { sitter } } = stores;
  const [acceptingPayment, setAcceptingPayment] = useState<boolean>(sitter.acceptingPayment || false);
  const [disableSwitch, setDisableSwitch] = useState<boolean>(false);

  const handleToggle = async (): Promise<void> => {
    if (!sitter.id) {
      return;
    }

    setDisableSwitch(true);

    const data = {
      id: sitter.id,
      acceptingPayment: !acceptingPayment,
    };

    try {
      await SitterPaymentSettingsService.patch(sitter.id, data);
      setAcceptingPayment(!acceptingPayment);
      await stores.sitter.refreshSitter();
    } catch (e) {
      if (axios.isAxiosError(e) && e.response?.data.errors) {
        toast.error(e.response.data.errors[0].message);
      } else {
        console.warn(e);
      }
    } finally {
      setDisableSwitch(false);
    }
  };

  return (
    <div className='flex flex-row'>
      <div className='mr-4 mt-1'>
        <ToggleSwitch id='accepting-payment-toggle' checked={acceptingPayment} disabled={disableSwitch} handleClick={handleToggle}/>
      </div>
      <div>
        <label htmlFor='accepting-payment-toggle' className='font-semibold mb-2'>
          {t('pages.sitter.payout.active.acceptDepositHeading')}
        </label>
        {acceptingPayment ? (
          <>
            <div className='mb-3'>
              {t('pages.sitter.payout.active.acceptDepositBody1')}
            </div>
            <div>
              {t('pages.sitter.payout.active.acceptDepositBody2')}
            </div>
          </>
        ) : (
          <div>
            {t('pages.sitter.payout.active.declineDepositBody')}
          </div>
        )}
      </div>
    </div>
  );
};
